const bucketForHeading = (heading) => {
  const h = String(heading || "").toLowerCase();
  if (h.includes("root cause")) return "root";
  if (h.includes("priority action") || h.includes("action item") || h.includes("priority")) return "actions";
  if (h.includes("recommend")) return "recs";
  return "insights";
};

export const splitIntoInsightBuckets = (markdown) => {
  const text = String(markdown || "").trim();
  const buckets = { insights: "", root: "", recs: "", actions: "" };
  if (!text) return buckets;

  const re = /^##\s+(.+)$/gm;
  const matches = [];
  let m;
  while ((m = re.exec(text)) !== null) {
    matches.push({ title: m[1].trim(), index: m.index });
  }
  if (matches.length === 0) {
    buckets.insights = text;
    return buckets;
  }

  for (let i = 0; i < matches.length; i++) {
    const cur = matches[i];
    const next = matches[i + 1];
    const start = cur.index;
    const end = next ? next.index : text.length;
    const block = text.slice(start, end).trim();
    const normalized = block.replace(/^##\s+/m, "### ");
    const bucket = bucketForHeading(cur.title);
    buckets[bucket] = (buckets[bucket] ? `${buckets[bucket]}\n\n` : "") + normalized;
  }

  return buckets;
};
